// import userServices from '@/services/member';
const state = { user: null }

const getters = {
    getMember: state => {
        return state.user
    }
}

const mutations = {
    updateLine: (state, payload) => {
        state.user = payload
    }
}

const actions = {

}


export default {
    state,
    mutations,
    getters,
    actions
}